<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Welcome!</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center">
                <base-button @click="signIn" type="primary" native-type="submit" class="my-4">Sign in</base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      user: '',
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  methods: {
    signIn() {
      this.$store
        .dispatch("authStore/signIn", { root: true })
        .then(response => {
          const accessToken = sessionStorage.getItem("accessToken");
          if (accessToken) {
            this.$router.push('/techDashboard');
          }
        }
        )
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
